var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { role: "region", "aria-label": "Cookie policy notice" } },
    [
      !_vm.isApp && !_vm.$vuetify.breakpoint.mdAndDown
        ? _c(
            "div",
            [
              _c(
                "v-dialog",
                {
                  attrs: {
                    width: "270",
                    transition: "dialog-bottom-transition",
                    "aria-modal": "true",
                    "aria-labelledby": "cookie-dialog-heading",
                  },
                  model: {
                    value: _vm.cookiesVisibility,
                    callback: function ($$v) {
                      _vm.cookiesVisibility = $$v
                    },
                    expression: "cookiesVisibility",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        {
                          staticClass: "text-subtitle-1",
                          attrs: {
                            id: "cookie-dialog-heading",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("components.cookies.title")) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("components.cookies.info")) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                "aria-label": _vm.$t(
                                  "components.cookies.buttons.read"
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toRead()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("components.cookies.buttons.read")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "accent--text",
                              attrs: {
                                color: "primary",
                                "aria-label": _vm.$t(
                                  "components.cookies.buttons.ok"
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  _vm.cookiesVisibility = 0
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("components.cookies.buttons.ok")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isApp || _vm.$vuetify.breakpoint.mdAndDown
        ? _c(
            "v-flex",
            { attrs: { xs12: "", sm12: "", md12: "", lg12: "" } },
            [
              _c(
                "v-alert",
                {
                  staticClass: "mt-12 mb-0",
                  attrs: {
                    dismissible: "",
                    border: "left",
                    type: "info",
                    color: "secondary",
                    "aria-live": "polite",
                  },
                  model: {
                    value: _vm.cookiesVisibility,
                    callback: function ($$v) {
                      _vm.cookiesVisibility = $$v
                    },
                    expression: "cookiesVisibility",
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("components.cookies.info")) +
                      "\n      "
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "ml-1 underline",
                      attrs: {
                        tag: "a",
                        to: _vm.tcPolicy,
                        "aria-label": "Read the full cookie policy",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("components.cookies.buttons.link")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  !_vm.cookiesVisibility
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "accent",
                            fab: "",
                            small: "",
                            "aria-label": "Re-open cookie notice",
                          },
                          on: {
                            click: function ($event) {
                              _vm.cookiesVisibility = 1
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("\n          fal fa-cookie-bite\n        "),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Open cookie notice"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }